import styled from 'styled-components';
import Button from '../Button';
import { fontWeight, space } from '../../style/utils';

const WidgetButton = styled(Button)`
  font-weight: ${fontWeight('regular')};
  background: ${({ theme }) => theme.palette.surface.subtle};
  color: ${({ theme }) => theme.palette.content.primary};
  line-height: normal;
  gap: ${space('xs')};

  .MuiButton-startIcon,
  .MuiButton-endIcon {
    margin: unset;
  }

  :hover {
    background: ${({ theme }) => theme.palette.surface.shade};
    color: ${({ theme }) => theme.palette.content.primary};
  }

  :disabled {
    cursor: not-allowed;
    background: ${({ theme }) => theme.palette.surface.subtle};

    svg {
      opacity: 0.3;
    }
  }
`;

WidgetButton.defaultProps = {
  ...WidgetButton.defaultProps,
  size: 'extraSmall',
};

export default WidgetButton;
